import { defineLanguage } from "../registry";

export default defineLanguage({ id: "jsx", runner: "javascript" });
